import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

import CascateList from "../../../../../../common/components/cascate_list";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DefaultInput from "../../../../../../common/components/default_input";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";

/**
 * Header
 */

type Props = {
  nome?: string,
  login?: string,
  idsGrupoAcesso?: number[],
  ddlGrupoAcesso: DropDown[],
  ddlCentroCusto: DropDown[],
  idsCentroCusto?: number[],
  email?: string,
  status?: number,

  handleNomeChange: (v: string) => void,
  handleLoginChange: (v: string) => void,
  handleIdsGrupoAcessoChange: (v: number[]) => void,
  handleIdsCentroCustoChange: (v: number[]) => void,
  handleEmailChange: (v: string) => void,
  handleStatusChange: (x: number) => void,
  handleClearFilters: () => void,
};

export const Header = ({
  nome,
  login,
  status,
  email,
  ddlCentroCusto,
  ddlGrupoAcesso,
  idsCentroCusto,
  idsGrupoAcesso,
  handleNomeChange,
  handleLoginChange,
  handleIdsGrupoAcessoChange,
  handleIdsCentroCustoChange,
  handleEmailChange,
  handleStatusChange,
  handleClearFilters,
}: Props) => {
  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 grid-flow-row-dense ">
            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 " >
              <div className="w-full">
                <DefaultInput
                  name='nome'
                  label='Nome'
                  value={nome}
                  onChangeValue={handleNomeChange} />
              </div>

              <div className="w-full">
                <DefaultInput
                  name='login'
                  label='Login'
                  value={login}
                  onChangeValue={handleLoginChange} />
              </div>

              <div className="w-full">
                <DefaultMultiAutocomplete
                  label='Grupos de Acesso'
                  value={ddlGrupoAcesso.filter(x => idsGrupoAcesso?.includes(x.id))}
                  options={ddlGrupoAcesso}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdsGrupoAcessoChange(x?.map(y => y.id) ?? [])} />
              </div>
            </div>

            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 " >
              <div className="w-full">
                <DefaultInput
                  name='email'
                  label='Email'
                  value={email}
                  onChangeValue={handleEmailChange} />
              </div>

              <FormControl size="small" fullWidth>
                <InputLabel id="modulo-dashboard">Status</InputLabel>
                <Select
                  labelId="modulo-dashboard"
                  label="Status"
                  value={status}
                  onChange={(e) => handleStatusChange(e.target.value)}>
                  <MenuItem value={2}>Todos</MenuItem>
                  <MenuItem value={0}>Ativos</MenuItem>
                  <MenuItem value={1}>Bloqueados</MenuItem>
                </Select>
              </FormControl>

              <div className="w-full">
                <DefaultMultiAutocomplete
                  label='Centro de Custo'
                  value={ddlCentroCusto.filter(x => idsCentroCusto?.includes(x.id))}
                  options={ddlCentroCusto}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdsCentroCustoChange(x?.map(y => y.id) ?? [])} />
              </div>
            </div>

          </div>
          <div className="w-full flex justify-end">
            <div className="w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={handleClearFilters}>
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>
        </div>
      </CascateList>
    </>
  );
}